import { useState } from 'react';
import { rsme, type Order } from '../lib/rsme';
import { useQuery } from '../ui/useQuery';
import { PageHead, Card, Pill, Input, Loading, ErrorState, EmptyState } from '../ui/primitives';

const STATUSES: Order['status'][] = ['active', 'reserved', 'completed', 'cancelled'];

export default function Orders() {
  const [search, setSearch] = useState('');
  const [status, setStatus] = useState<Order['status'] | ''>('active');
  const q = useQuery(() => rsme.orders.list({ search, status: status || undefined, limit: 100 }), [search, status]);

  return (
    <div className="max-w-6xl mx-auto">
      <PageHead title="Orders" sub="Rentals in flight, recently completed, and reserved" />
      <div className="px-5 md:px-8 flex flex-wrap gap-2 items-center">
        <Input value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Search order, company, PO, quote no" className="md:max-w-sm" />
        <select value={status} onChange={(e) => setStatus(e.target.value as any)} className="h-10 px-3 rounded-lg bg-elevated border border-line text-sm">
          <option value="">all</option>
          {STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
        </select>
      </div>

      <div className="px-5 md:px-8 mt-4">
        {q.loading && <Loading rows={6} />}
        {q.error && <ErrorState error={q.error} retry={q.refetch} />}
        {!q.loading && !q.error && !q.data?.data?.length && <EmptyState title="No orders" />}
        {q.data?.data && (
          <div className="space-y-2">
            {q.data.data.map((o) => (
              <Card key={o.id} className="!p-4">
                <div className="flex items-start gap-3 flex-wrap">
                  <div className="min-w-0 flex-1">
                    <div className="flex items-center gap-2">
                      <span className="font-semibold tabular-nums">{o.orderNumber}</span>
                      <Pill tone={o.status === 'active' ? 'good' : o.status === 'completed' ? 'muted' : o.status === 'cancelled' ? 'danger' : 'accent'}>{o.status}</Pill>
                    </div>
                    <div className="text-sm mt-1 truncate">{o.assetName} <span className="text-muted">· {o.tonnage}T · {o.company}</span></div>
                    <div className="text-xs text-muted mt-1">
                      {o.rentOutDate} → {o.returnDate ?? '—'} · rate {o.rate ?? '—'} {o.term ?? ''} · {o.salesPerson ?? '—'}
                    </div>
                  </div>
                </div>
              </Card>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
